export default __webpack_public_path__ + "static/reviews-graphics-left-4be8687a2d364bfbb51585daccc39ecd.svg";